var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',{class:_vm.someData == '1' && _vm.page_name == 'index'
        ? 'zs color_fff'
        : 'zs color_000'},[_vm._v(" "+_vm._s(_vm.info.copyright)+" ")]),_c('p',[_c('a',{class:_vm.someData == '1' && _vm.page_name == 'index'
          ? 'zs color_fff'
          : 'zs color_000',staticStyle:{"text-decoration":"none"},attrs:{"href":"https://beian.miit.gov.cn"}},[_vm._v("Powered by NineTon Technology Co. Ltd.渝ICP备13005440号-1")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }